<template>
    <div class="SubjectBox">
        <!-- 标题 -->
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <!-- 搜索框 -->
        <div class="searchCon">
          <div class="searchMain">
            <ots-refer :selectList="selectList" :request-form="requestForm" @search="getResult" />
          </div>
        </div>
        <!-- 列表 -->
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :tableData="tableData"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>
        <!-- 弹窗 -->
        <ots-custom-dialog :dialog.sync="addDialog" :title="!addOrEdit?'编辑层次':'添加层次'" width="40%">
          <template v-slot:content>
            <div>
              <el-form ref="form" :model="form" :rules="rules">
                <el-form-item label="层次名称" class="childrenName" prop="levelName">
                  <el-input v-model.trim="form.levelName" placeholder="请输入"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round @click="addDialog=false">取消</el-button>
            <el-button round type="primary" @click="addSubject" v-if="addOrEdit">确定</el-button>
            <el-button round type="primary" @click="editLevelFn" v-else>确定</el-button>
          </template>
        </ots-custom-dialog>
    </div>
</template>
<script>
import { selectLevel, insertLevelSet, editLevelSet, deleteLevelSet, exportLevelBlurredAPI } from '@/http/modules/baseSet/majorCourse';
export default {
  name: 'level',
  data () {
    return {
      selectList: [
        {
          title : '层次名称',
          type : 'input',
          placeholder : '请输入层次名称',
          requestKey: "levelName"
        }
      ],
      requestForm: {
        levelName: '',
      },
      tableHeader: [
        {
          title: "层次名称",
          prop: "name"
        },
        {
          title:"操作",
          type:"buttons",
          width:"100",
          btnList:[
            { title:"编辑", click: this.editLevel },
            { title:"删除", click: this.deleteLevel },
          ]
        }
      ],
      tableData: [],
      form: {
        levelName: '',
      },
      rules: {
        levelName: [
          { required: true, message: '请输入层次名称', trigger: 'blur'},
          { min: 1, max: 30, message: '输入范围在 1 到 30 个字符', trigger: 'blur' }
        ]
      },
      mainTopBtnList: [
        {
          title: '新增',
          fn: this.addSubjectDialog,
          plain: true
        },
        {
          title: "导出",
          fn: this.exportExcel
        }
      ],
      addDialog: false,
      pagination: {
        total: 0
      },
      SubjectListParams: {
        page: 1, 
        size: 10
      },
      addOrEdit: true,
    }
  },
  created () {
    this.getAllLevelFn()
  },

  methods: {
    async exportExcel() {
      const { data, code } = await exportLevelBlurredAPI();
      if (code) {
        window.open(data);
      }
    },

    /*************************************
     * @this 查询表格数据
     *************************************/
    async getAllLevelFn () {
      this.SubjectListParams = Object.assign(this.SubjectListParams, this.requestForm)
      let params = { ...this.SubjectListParams }
      selectLevel(params).then( res => {
        this.tableData = res.data.records
        this.pagination.total = res.data.total
      })
    },

    /******************************
     * @this 添加层次弹窗开启
     *****************************/
    addSubjectDialog () {
      this.resetForm()
      this.addDialog = true
      this.addOrEdit = true
    },

    /******************************
     * @this 添加层次
     *****************************/
    addSubject () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let params = { ...this.form }
          insertLevelSet(params).then( res => {
            if (res.code == 1) {
              this.$message.success('添加成功！')
              this.addAfter()
            }
          })
        } else {
          return false
        }
      });
    },

    /*******************************
     * @this 开启编辑层次弹窗
     *******************************/
    editLevel (row) {
      this.form.levelName = row.name
      this.form.levelId = row.id
      this.addOrEdit = false
      this.addDialog = true
    },

    /*******************************
     * @this 编辑层次
     *******************************/
    editLevelFn() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let params = { ...this.form }
          editLevelSet(params).then( res => {
            if (res.code == 1) {
              this.$message.success('操作成功！')
              this.addAfter()
            }
          })
        } else {
          return false;
        }
      });
    },

    /*******************************
     * @this 删除层次
     *******************************/
    deleteLevel(row) {
      this.$confirm('确定删除该层次?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        deleteLevelSet({levelId: row.id}).then(res => {
          if (res.code ==1) {
            this.$message.success('操作成功！')
            this.getAllLevelFn()
          }
        })
      })
    },

    /***************************
     * @this 重置表单数据
     **************************/
    resetForm() {
      this.form = {
        levelName: ''
      }
    },

    /******************************************
     * @this 添加,编辑之后,重置表单数据和表格数据
     ******************************************/
    addAfter () {
      this.addDialog = false
      this.resetForm()
      this.getAllLevelFn()
    },

    /***************************
     * @this 分页-每页数量
     **************************/
    changeSize(num) {
        this.SubjectListParams.size = num
        this.getAllLevelFn()
    },

    /***************************
     * @this 分页-页码
     **************************/
    changePage(p) {
        this.SubjectListParams.page = p
        this.getAllLevelFn()
    },

    /***************************
     * @this 查询按钮,重置页码为1
     **************************/
    getResult () {
      this.SubjectListParams.page = 1
      this.getAllLevelFn()
    },
  }
}
</script>

<style lang="less" scoped>
.SubjectBox {
  .searchCon {
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    .searchMain {
      flex: 1;
    }
    .searchBtn {
      flex-shrink: 0;
      width: 72px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .mainCon {
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
  }
}
.tipIcon{
    position: relative;
    .tips {
      font-size: 13px;
      position: absolute;
      color: #fff;
      width: 176px;
      text-align: center;
      padding: 10px;
      top: -48px;
      left: -90px;
      background: rgba(0, 0, 0, 0.85);
    }
    .tips::after{
      content: '';
      border: 5px solid transparent;
      border-top-color: rgba(0, 0, 0, 0.85);
      position: absolute;
      top: 33px;
      left: 96px;
    }
}
</style>